<script>
export default {
  data () {
    return {
      lineData: {
        x: {
          min: null,
          max: null,
          main: null,
          custom: null
        },
        y: {
          min: null,
          max: null,
          main: null,
          custom: null
        }
      }
    }
  },
  created () {
    Object.keys(this.boardData).forEach(id => {
      this.boardInit(id)
    })
  },
  methods: {
    boardInit (id) {
      const boardData = {
        grabID: -1,
        grabType: '',
        grabTarget: null,
        baseX: 0,
        grabX: 0,
        baseY: 0,
        grabY: 0
      }
      this.boardData[id] = {
        ...this.boardData[id],
        ...boardData
      }
    },
    boardEvent (id, e, functions) {
      // rect
      let targetData = e.target.getBoundingClientRect()
      let containerData = e.currentTarget.getBoundingClientRect()
      // line
      let lx = targetData.x - containerData.x + (targetData.width / 2)
      let ly = targetData.y - containerData.y + (targetData.height / 2)
      // grab
      let grabID = e.target.getAttribute('grab-id')
      grabID = grabID || grabID === 0 ? grabID - 0 : -1
      let grabType = (e.target.getAttribute('grab-type') || '').split('*')
      let grabXMin = (e.target.getAttribute('grab-x-min') || '').split('*')
      grabXMin = grabXMin.length && grabXMin[0] ? {
        value: lx - Math.max(Math.min(lx, grabXMin[0] - 0), 0),
        display: grabXMin.length <= 1
      } : {
        value: lx - (0 + (targetData.width / 2)),
        display: false
      }
      let grabXMax = (e.target.getAttribute('grab-x-max') || '').split('*')
      grabXMax = grabXMax.length && grabXMax[0] ? {
        value: Math.min(Math.max(lx, grabXMax[0] - 0), containerData.width) - lx,
        display: grabXMax.length <= 1
      } : {
        value: (containerData.width - (targetData.width / 2)) - lx,
        display: false
      }
      let grabXCustom = (e.target.getAttribute('grab-x-custom') || '').split('*')
      grabXCustom = grabXCustom.length && grabXCustom[0] ? {
        value: Math.min(Math.max(0, grabXCustom[0] - 0), containerData.width),
        display: grabXCustom.length <= 1
      } : {
        value: (containerData.width - (targetData.width / 2)) - lx,
        display: false
      }
      let grabYMin = (e.target.getAttribute('grab-y-min') || '').split('*')
      grabYMin = grabYMin.length && grabYMin[0] ? {
        value: ly - Math.max(Math.min(ly, grabYMin[0] - 0), 0),
        display: grabYMin.length <= 1
      } : {
        value: ly - (0 + (targetData.height / 2)),
        display: false
      }
      let grabYMax = (e.target.getAttribute('grab-y-max') || '').split('*')
      grabYMax = grabYMax.length && grabYMax[0] ? {
        value: Math.min(Math.max(ly, grabYMax[0] - 0), containerData.width) - ly,
        display: grabYMax.length <= 1
      } : {
        value: (containerData.height - (targetData.height / 2)) - ly,
        display: false
      }
      let grabYCustom = (e.target.getAttribute('grab-y-custom') || '').split('*')
      grabYCustom = grabYCustom.length && grabYCustom[0] ? {
        value: Math.min(Math.max(0, grabYCustom[0] - 0), containerData.width),
        display: grabYCustom.length <= 1
      } : {
        value: (containerData.width - (targetData.width / 2)) - lx,
        display: false
      }
      let cx = Math.max(Math.min(e.clientX - containerData.x, containerData.width), 0)
      let cy = Math.max(Math.min(e.clientY - containerData.y, containerData.height), 0)
      // data
      let grabData = {
        id: grabID,
        type: grabType[0],
        xRange: [grabXMin, grabXMax, grabXCustom],
        yRange: [grabYMin, grabYMax, grabYCustom],
        target: e.target,
        x: cx,
        y: cy
      }
      let lineData = {
        x: lx,
        y: ly,
        display: grabType.length <= 1
      }
      // f
      for (let f of functions) {
        f(id, grabData, lineData)
      }
    },
    boardStart (id, grabData, lineData) {
      if (grabData.id >= 0 && grabData.type) {
        this.boardData[id].grabID = grabData.id
        this.boardData[id].grabType = grabData.type
        this.boardData[id].grabTarget = grabData.target
        if (['all', 'x'].includes(grabData.type)) {
          this.boardData[id].baseX = this.boardData[id].grabX = grabData.x
          this.lineData.x.main = {
            base: lineData.x,
            grab: 0,
            display: lineData.display
          }
          if (grabData.xRange[0]) {
            this.lineData.x.min = {
              value: lineData.x - grabData.xRange[0].value,
              display: grabData.xRange[0].display
            }
          }
          if (grabData.xRange[1]) {
            this.lineData.x.max = {
              value: lineData.x + grabData.xRange[1].value,
              display: grabData.xRange[1].display
            }
          }
          if (grabData.xRange[2]) {
            this.lineData.x.custom = {
              value: grabData.xRange[2].value,
              display: grabData.xRange[2].display
            }
          }
        }
        if (['all', 'y'].includes(grabData.type)) {
          this.boardData[id].baseY = this.boardData[id].grabY = grabData.y
          this.lineData.y.main = {
            base: lineData.y,
            grab: 0,
            display: lineData.display
          }
          if (grabData.yRange[0]) {
            this.lineData.y.min = {
              value: lineData.y - grabData.yRange[0].value,
              display: grabData.yRange[0].display
            }
          }
          if (grabData.yRange[1]) {
            this.lineData.y.max = {
              value: lineData.y + grabData.yRange[1].value,
              display: grabData.yRange[1].display
            }
          }
          if (grabData.yRange[2]) {
            this.lineData.y.custom = {
              value: grabData.yRange[2].value,
              display: grabData.yRange[2].display
            }
          }
        }
        (this.boardData[id].onStart || (() => {}))({ ...this.boardData[id] })
      }
    },
    boardMove (id, grabData) {
      if (this.boardData[id].grabID >= 0) {
        if (['all', 'x'].includes(this.boardData[id].grabType)) {
          let grabX = grabData.x
          let lineGrab = this.boardData[id].grabX - this.boardData[id].baseX
          if (this.lineData.x.min) {
            grabX = Math.max(grabX, this.lineData.x.min.value - this.lineData.x.main.base + this.boardData[id].baseX)
            lineGrab = Math.max(lineGrab, this.lineData.x.min.value - this.lineData.x.main.base)
          }
          if (this.lineData.x.max) {
            grabX = Math.min(grabX, this.lineData.x.max.value - this.lineData.x.main.base + this.boardData[id].baseX)
            lineGrab = Math.min(lineGrab, this.lineData.x.max.value - this.lineData.x.main.base)
          }
          this.boardData[id].grabX = grabX
          this.lineData.x.main.grab = lineGrab
        }
        if (['all', 'y'].includes(this.boardData[id].grabType)) {
          let grabY = grabData.y
          let lineGrab = this.boardData[id].grabY - this.boardData[id].baseY
          if (this.lineData.y.min) {
            grabY = Math.max(grabY, this.lineData.y.min.value - this.lineData.y.main.base + this.boardData[id].baseY)
            lineGrab = Math.max(lineGrab, this.lineData.y.min.value - this.lineData.y.main.base)
          }
          if (this.lineData.y.max) {
            grabY = Math.min(grabY, this.lineData.y.max.value - this.lineData.y.main.base + this.boardData[id].baseY)
            lineGrab = Math.min(lineGrab, this.lineData.y.max.value - this.lineData.y.main.base)
          }
          this.boardData[id].grabY = grabY
          this.lineData.y.main.grab = lineGrab
        }
        (this.boardData[id].onMove || (() => {}))({ ...this.boardData[id] })
      }
    },
    boardEnd (id) {
      if (this.boardData[id].grabID >= 0) {
        (this.boardData[id].onEnd || (() => {}))({ ...this.boardData[id] })
      }
      this.boardInit(id)
      this.lineData = {
        x: {
          min: null,
          max: null,
          main: null
        },
        y: {
          min: null,
          max: null,
          main: null
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/customGrab.vue